module.exports = __webpack_public_path__ + "assets/img/bright-spot-bg.932574a2.png";